import { forwardRef, useState } from 'react';
import { Field } from 'formik';
import { FormControl, Stack, FormLabel, Box, Text } from '@chakra-ui/react';
import FieldToolTip from 'components/forms/new/FieldToolTip';
import walkthroughIds from '../walkthroughIds';
import {
    stackSpacing,
    formLabelStyling,
    stackStyling,
    dropDownFormStyle,
    descriptionStyling,
} from 'components/forms/new/formStyles';
import { Select } from 'chakra-react-select';


const InternationalRatePartnerField = ({ errors, touched, darkMode, partnerOptions, }) => {
    const [isHovered, setIsHovered] = useState(false);
    const { createMode } = walkthroughIds;
    const ChakraSelect = forwardRef((props, ref) => (
        <Select selectedOptionColor="brand" ref={ref} {...props} />
    ));
    ChakraSelect.displayName = "ChakraSelect";
    console.log('Partner Options:', partnerOptions);
    console.log('Partner Options length:', partnerOptions?.length);
    return (
        <FormControl
            isInvalid={!!errors.selectiveSyncPolicy && touched.selectiveSyncPolicy}
            sx={{ margin: '0 !important', paddingBottom: '10px' }}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
        >
            <Stack direction="row" spacing={stackSpacing} sx={stackStyling()} align="center">
                <Box>
                    <FormLabel sx={formLabelStyling(darkMode)}>
                        Partner
                    </FormLabel>
                    <Text sx={descriptionStyling} maxWidth={250}>
                        Choose the partner for this international rate.
                    </Text>
                </Box>
                <Box
                    flex="1"
                    sx={{
                        paddingTop: '15px',
                    }}
                >
                    <Field name="partnerID">
                        {({ form }) => {
                            const selectedOption = form.values.partnerID 
                                ? partnerOptions?.find((op) => op.value === form.values.partnerID) || null
                                : null;
                            return (
                                <ChakraSelect
                                    minWidth="410px"
                                    width="100%"
                                    // data-walkthroughid={createMode.ufSelectiveSyncSelect}
                                    options={partnerOptions}
                                    placeholder="- Select Partner -"
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                    }}
                                    getOptionLabel={(i) => i.label}
                                    getOptionValue={(i) => i.value}
                                    chakraStyles={dropDownFormStyle(darkMode)}
                                    isLoading={form.isSubmitting}
                                    isDisabled={form.isSubmitting}
                                    value={selectedOption}
                                    onChange={(option) => {
                                        if (option) {
                                            // Selecting a partner: update both ID and name
                                            form.setFieldValue('partnerID', option.value);
                                            form.setFieldValue('partner', option.label);
                                        } else {
                                            // Clearing: only set ID to null, keep partner name as is
                                            form.setFieldValue('partnerID', null);
                                        }
                                        form.validateField('partnerID');
                                    }}
                                    isClearable
                                    onBlur={() => {
                                        form.setFieldTouched('partnerID', true);
                                    }}
                                />
                            );
                        }}
                    </Field>
                </Box>
                {isHovered && (
                    <FieldToolTip
                        label="Choose the partner for this international rate."
                        ariaLabel="international-rate-partner-tip"
                        left="25px"
                        top="10px"
                    />
                )}
            </Stack>
        </FormControl>
    );
};

export default InternationalRatePartnerField;